import { useEffect } from "react";
import { CircleGeometry, Mesh, PlaneGeometry, TextureLoader } from "three";
import { useThree } from "@react-three/fiber";
import { Reflector } from "three/addons/objects/Reflector.js";
import { getMeshParams } from "helpers";
import { getMaterial } from "materials";
import drain from "textures/drain.jpg";

const Mirrors = ({ mirrors, type }) => {
    const { scene } = useThree();

    useEffect(() => {
        mirrors.forEach((mesh) => {
            const { rotate, position, width, height } = getMeshParams(mesh, 0.01);
            let plane, dx, dy, dz;
            if (type === -13) {
                plane = new PlaneGeometry(width * 1.05, height * 1.05);
                dx = 0;
                dy = 1.675;
                dz = 2.5;
            } else {
                plane = new CircleGeometry(width / 2);
                dx = 0;
                dy = 2.05;
                dz = 2.49;
            }
            const mirror = new Reflector(plane, {
                // clipBias: 0.003,
                // clipBias: 0.3,
                textureWidth: 1024,
                textureHeight: 1024,
                color: 0xb5b5b5,
            });

            console.log("mirror: ", mirror);
            mirror.position.set(position[0] + dx, position[1] + dy, position[2] + dz);
            if (type === -13) mirror.rotation.set(...rotate);
            else mirror.rotation.set(0, Math.PI, 0);

            scene.add(mirror);
        });

        const plane = new PlaneGeometry(0.13, 0.13);
        const material = getMaterial("marble", "rgb(100, 100, 100)");
        const texture = new TextureLoader().load(drain);
        material.map = texture;
        const mesh = new Mesh(plane, material);
        mesh.position.set(1.387, -1.498, -1.132);
        mesh.rotation.set(-Math.PI / 2, 0, 0);
        scene.add(mesh);
    }, [mirrors, scene, type]);

    return <></>;
};

export default Mirrors;
